export default {
  header: 'Furnace info',
  text: 'Text',
  bgColor: 'Background color',
};
